export default "__VITE_ASSET__B3voWN_T__"